import { useQueryClient } from '@tanstack/react-query';

/** Shared look of Ask Clarid's cards. */
export const shell = 'rounded-lg border bg-white px-4 py-3 text-sm';
export const primaryBtn =
  'inline-flex items-center gap-1.5 rounded-md bg-ocean-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-ocean-700 disabled:opacity-50';
export const secondaryBtn =
  'inline-flex items-center gap-1.5 rounded-md border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50';

/** Re-read a conversation's cards after a decision. */
export function useRefresh(queryKey: unknown[]) {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey });
}
